import { clientList } from './list';
export var isClient = function (type) { return clientList.includes(type); };
